import React from 'react'
import Navigation from '../reusableComponent/Navigation'
import Footer from '../reusableComponent/Footer'
import Career from '../reusableComponent/Career'

const NavCareer = () => {
    return (
        <div>
            <Navigation />
            <Career />
            <Footer />

        </div>
    )
}

export default NavCareer